<template>
  <div class="page_title">
    <div class="page_list">
      <div class="name">{{title}}</div>
      <div>
        <Button v-if="butShow" class="mg-right20" @click="$base.linkBack()">{{ $t("back") }}</Button>
        <Button
          v-if="newButShow"
          type="primary"
          class="mg-right20"
          @click="newBut()"
        >{{ $t("add") }}</Button>
      </div>
    </div>
    <Divider />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    butShow: Boolean,
    newButShow: Boolean,
  },
  methods: {
    newBut () {
      this.$emit('newBut');
    }

  },
}
</script>
<style lang="less" scoped>
.page_title {
  /deep/ .ivu-divider-horizontal {
    margin: 10px 0 24px 0;
  }
  .page_list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 17px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageTitle.vue